import './_Navbar.scss';

function Navbar({ onOpenResumeModal }) {
  return (
    <header className="navbar-container">
      <nav className="navbar" aria-label="Primary navigation">
        <a href="#projects">Projects</a>
        <a href="#contact">Contact</a>
        <button
          type="button"
          onClick={onOpenResumeModal}
          className="navbar-resume-btn"
          aria-label="Open resume download modal"
        >
          Resume
        </button>
      </nav>
    </header>
  );
}

export default Navbar;
